export const sciton = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 38,
  inputPaddingInline: 25,

  inputHeight: 50,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Arial", sans-serif',
  inputColor: "#252525",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#A9A9A9",
  inputBorderWidth: 1,
  inputBorderRadius: 4,

  inputHoverColor: "#252525",
  inputHoverBorderColor: "#A9A9A9",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 38,
  selectPaddingInline: 25,

  selectHeight: 50,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Arial", sans-serif',
  selectColor: "#252525",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "#A9A9A9",
  selectBorderWidth: 1,
  selectBorderRadius: 4,

  selectHoverColor: "#252525",
  selectHoverBorderColor: "#A9A9A9",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 38,
  textAreaPaddingInline: 25,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Arial", sans-serif',
  textAreaColor: "#252525",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#A9A9A9",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 4,

  textAreaHoverColor: "#252525",
  textAreaHoverBorderColor: "#A9A9A9",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#252525",
  placeholderFontFamily: '"Arial", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#252525",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#717171",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#717171",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Arial", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#717171",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Arial", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 30,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 4,
  checkboxUncheckedBorderColor: "#FFFFFF",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBorderColor: "#FFFFFF",
  checkboxCheckedColor: "#252525",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Arial", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#FFFFFF",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 14,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#FFFFFF",
  radioUncheckedBackgroundColor: "#FFFFFF",
  radioCheckedBackgroundColor: "#252525",
  radioCheckedBorderColor: "#FFFFFF",

  radioAlignment: "none",

  radioLabelFontFamily: '"Arial", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#FFFFFF",

  // **********************************
  // submit button

  submitMarginTop: 42,
  submitFontSize: 14,
  submitFontFamily: "'Arial', sans-serif",
  submitWidth: 100,
  submitWidthUnits: "px",
  submitHeight: 50,
  submitBorderRadius: 25,
  submitBorderWidth: 1,
  submitBackground: "#FFFFFF",
  submitColor: "#252525",
  submitBorderColor: "#FFFFFF",
  submitBackgroundHover: "#FFFFFF",
  submitBorderColorHover: "#FFFFFF",
  submitColorHover: "#252525",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  